import { EntitySelectorsFactory } from '@ngrx/data';

import { TipoDivisorMuestra } from './tipos-divisor-muestra.model';

export const tiposDivisorMuestraSelectors =
  new EntitySelectorsFactory().create<TipoDivisorMuestra>('TipoDivisorMuestra');

export const selectAllTiposDivisorMuestra =
  tiposDivisorMuestraSelectors.selectEntities;
